export default {"src":"/login-app/[GIT_HASH]/_next/static/media/dagster_solid.6ce92302.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};